export interface AppropriationUpdateRequest {
  appropriationTitle: string;
  appropriationAmount: number;
  comment?: string;
}
